export const ROUTE_MAPPING = {
  '/': { name: 'Landing Page', category: 'public', priority: 'high' },
  '/login': { name: 'Login', category: 'auth', priority: 'high' },
  '/signup': { name: 'Signup', category: 'auth', priority: 'high' },
  '/verify-email': { name: 'Email Verification', category: 'auth', priority: 'medium' },
  '/forgot-password': { name: 'Forgot Password', category: 'auth', priority: 'medium' },
  '/reset-password': { name: 'Reset Password', category: 'auth', priority: 'medium' },
  
  // Dashboard Routes
  '/dashboard': { name: 'Dashboard Home', category: 'dashboard', priority: 'high' },
  '/settings': { name: 'Settings', category: 'settings', priority: 'medium' },
  '/manage-portal': { name: 'Admin Portal', category: 'admin', priority: 'high' },
  
  // Subscription Routes
  '/user-subscription': { name: 'Subscription Plans', category: 'subscription', priority: 'high' },
  '/payment': { name: 'Payment', category: 'subscription', priority: 'high' },
  
  // Canvas Routes
  '/create-canvas': { name: 'Create Canvas', category: 'canvas', priority: 'high' },
  '/update-user-currency': { name: 'Update Canvas', category: 'canvas', priority: 'medium' },
  
  // Setup Routes
  '/setup-profile': { name: 'Profile Setup', category: 'setup', priority: 'high' },
  '/account': { name: 'Account Setup', category: 'setup', priority: 'high' },
  '/income': { name: 'Income Setup', category: 'setup', priority: 'high' },
  '/budget': { name: 'Budget Setup', category: 'setup', priority: 'high' },
  '/budget/manual': { name: 'Manual Budget Setup', category: 'setup', priority: 'medium' },
  '/budget/upload': { name: 'Budget Upload', category: 'setup', priority: 'medium' },
  
  // Special Routes
  '/accept-invite': { name: 'Accept Invitation', category: 'invitation', priority: 'medium' },
  '/cashbot': { name: 'Cashbot', category: 'ai', priority: 'high' }
};